import styled from 'styled-components/macro';
import { Container, ContainerStyled } from '@yme/atoms/grid';
import { colorBlackTransparent300, colorCoreGray700, FILTER_DROP_SHADOW_DEFAULT, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { AspectRatio } from '@yme/utils/constants';
export const HeroBannerStyled = styled.div `
  position: relative;
  width: 100%;
  background-color: ${colorCoreGray700};
  max-width: 1920px;
  margin: 0 auto;

  aspect-ratio: ${({ aspectRatio = AspectRatio.RectangleLevel3 }) => aspectRatio};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  ${ADAPTIVE.minWidth.desktop} {
    max-height: 810px;
  }
`;
export const HeroContentWrapperStyled = styled.div `
  box-sizing: border-box;
  position: relative;
  overflow-wrap: break-word;
  height: 100%;

  ${ADAPTIVE.minWidth.desktop} {
    //safari fix
    max-height: 810px;
  }

  ${ContainerStyled} {
    ${ADAPTIVE.maxWidth.mobile} {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
`;
export const HeroSectionContainerStyled = styled(Container) `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  margin: 0 auto;

  // Common approach for all text inside of Hero Section
  filter: ${FILTER_DROP_SHADOW_DEFAULT};
`;
export const ImageBgStyled = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  picture {
    img {
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
`;
export const ImageMaskStyled = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }
`;
